import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import enUS from '../../translations/en-US.json';

@Injectable({
  providedIn: 'root',
})
export class I18nService {
  public defaultLanguage!: string;
  public supportedLanguages!: string[];

  constructor(private translateService: TranslateService) {
    // Embed languages to avoid extra HTTP requests
    translateService.setTranslation('en-US', enUS);
  }

  /**
   * Initializes i18n for the application.
   * Loads language from local storage if present, or sets default language.
   * @param defaultLanguage The default language to use.
   * @param supportedLanguages The list of supported languages.
   */
  public init(defaultLanguage: string, supportedLanguages: string[]): void {
    this.defaultLanguage = defaultLanguage;
    this.supportedLanguages = supportedLanguages;
    this.translateService.use(defaultLanguage);
  }

  public translate(key: string, interpolateParams?: object): string {
    return this.translateService.instant(key, interpolateParams);
  }
}
